.generalChatButton {
  .reset-button();

  display: flex;
  align-items: center;
  color: var(--x-color-text-accent);
  .text-subtitle-m();
  gap: 4px;

  &:hover {
    text-decoration: underline;
  }
}
